import {Component, Inject, ChangeDetectionStrategy} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle} from '@angular/material/dialog';
import {MatFormField, MatInput, MatLabel} from '@angular/material/input';
import {MatIcon} from '@angular/material/icon';
import {MatButton, MatIconButton} from '@angular/material/button';
import {FormsModule} from '@angular/forms';

export interface DropdownValueItem {
  value: string;
  numericValue: number | null;
}

export interface DropdownEditValuesDialogData {
  values: DropdownValueItem[];
  numericValueDisabled: boolean;
}

@Component({
  selector: 'app-dropdown-edit-values-dialog',
  imports: [
    MatFormField,
    MatIcon,
    MatLabel,
    MatInput,
    MatButton,
    MatIconButton,
    FormsModule,
    MatDialogContent,
    MatDialogTitle,
    MatDialogActions
  ],
  templateUrl: './dropdown-edit-values-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './dropdown-edit-values-dialog.component.scss'
})
export class DropdownEditValuesDialogComponent {
  values: DropdownValueItem[] = [];

  constructor(
    private dialogRef: MatDialogRef<DropdownEditValuesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DropdownEditValuesDialogData
  ) {
    this.values = data.values.map(item => ({
      value: item.value,
      numericValue: item.numericValue,
    }));
  }

  addValue(value: string, numericValue: string): void {
    const trimmedValue = value.trim();

    if (!trimmedValue) {
      return;
    }

    this.values.push({
      value: trimmedValue,
      numericValue: this.data.numericValueDisabled || numericValue === ''
        ? null
        : Number(numericValue),
    });
  }

  moveUp(index: number): void {
    if (index <= 0) {
      return;
    }

    [this.values[index - 1], this.values[index]] = [this.values[index], this.values[index - 1]];
  }

  moveDown(index: number): void {
    if (index >= this.values.length - 1) {
      return;
    }

    [this.values[index], this.values[index + 1]] = [this.values[index + 1], this.values[index]];
  }

  removeValue(index: number): void {
    this.values.splice(index, 1);
  }

  save(): void {
    const cleanedValues = this.values
      .map(item => ({
        value: item.value.trim(),
        numericValue: item.numericValue,
      }))
      .filter(item => item.value !== '');

    this.dialogRef.close(cleanedValues);
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
